const { default: ConfirmActionModal } = require("@/vue/components/modals/ConfirmActionModal.vue");

/**
 * @ngdoc Controller
 * @name LocationSettingsController
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('LocationSettingsController', LocationSettingsController);

    /**
     * @constructor
     * @ngInject
     */
    function LocationSettingsController(
        $log,
        $scope,
        $state,
        $q,
        $stateParams,
        InstallationsService,
        VrmModalService,
        locale,
        ApiService,
    ) {
        $log.info('LocationSettingsController');

        $q.all([
            InstallationsService.getInstallation($stateParams.id),
        ]).then(function(result) {
            var installation = result[0];

            redirectUnauthorizedUser(installation);

            $scope.map = {
                bounds: {},
                control: {},
                center: {
                    latitude: installation.data.lt ? installation.data.lt.rawValue : null,
                    longitude: installation.data.lg ? installation.data.lg.rawValue : null
                },
                coords: {
                    latitude: installation.data.lt ? installation.data.lt.rawValue : null,
                    longitude: installation.data.lg ? installation.data.lg.rawValue : null
                },
                zoom: 7,
            };

            $scope.save = function() {
                ApiService.installationSettings($stateParams.id, {
                    lat: $scope.map.coords.latitude,
                    lng: $scope.map.coords.longitude,
                }).then(function() {
                    InstallationsService.reload();
                });
            };

            $scope.reset = function() {
                VrmModalService.openVueModal(ConfirmActionModal, {
                    message: locale.getString('common.confirm_installation_location_reset'),
                    onConfirm: function() {
                        if ($scope.map.coords.latitude != null && $scope.map.coords.longitude != null) {
                            $scope.map.coords.latitude = null;
                            $scope.map.coords.longitude = null;
                            $scope.save();
                        }
                    }
                })
            }
        });

        const redirectUnauthorizedUser = (installation) => {
            if (!installation.view_permissions.update_settings) {
                InstallationsService.redirectUnauthorizedUser(installation);
            }
        }

        $scope.onLocationChanged = (e) => {
            $scope.map.coords = e;
            $scope.map.center = e;
        }
    }
})();
